import { I as i } from "../../constants-DeVuDy8J.js";
import { openBlock as n, createElementBlock as d, normalizeClass as o, createElementVNode as s } from "vue";
import { _ as l } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconFontSize",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(i).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return i[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, m = ["aria-label", "data-qa", "aria-hidden"];
function _(e, t, r, u, f, a) {
  return n(), d("svg", {
    "aria-label": r.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--font-size"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Font Size",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    s("path", {
      d: "M10 6.5h-.5V9a.5.5 0 0 1 0 1h-1a.5.5 0 0 1 0-1V6.5H8a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-1 0Zm-3-3V3H5v6h.5a.5.5 0 0 1 0 1h-2a.5.5 0 0 1 0-1H4V3H2v.5a.5.5 0 0 1-1 0v-1a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-1 0Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, m);
}
const z = /* @__PURE__ */ l(c, [["render", _]]);
export {
  z as default
};
//# sourceMappingURL=font-size.js.map
